import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Hero = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-zinc-950 pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1541888086425-d81bb19240f5?q=80&w=2070&auto=format&fit=crop" 
          alt="Baustelle Hintergrund" 
          className="w-full h-full object-cover opacity-40 grayscale mix-blend-luminosity"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/80 via-zinc-950/60 to-zinc-950"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-zinc-900/0 via-zinc-950/50 to-zinc-950/90"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block py-1 px-3 bg-zinc-900 border border-zinc-800 text-orange-500 text-xs font-bold tracking-widest uppercase mb-6 rounded-sm">
              Creator & Handwerker
            </span>
          </motion.div>

          <motion.h1 
            className="text-5xl md:text-7xl lg:text-8xl font-black uppercase tracking-tighter text-white mb-6 leading-none text-shadow-md"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            BAU. CONTENT. <br className="hidden md:block"/> 
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-yellow-500">REAL TALK.</span>
          </motion.h1>

          <motion.p 
            className="text-lg md:text-xl text-zinc-300 mb-10 max-w-2xl mx-auto font-medium"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Ich zeige echten Baustellen-Alltag – ungefiltert, direkt und auf den Punkt. Für Marken, die sichtbar werden wollen.
          </motion.p>

          <motion.div 
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <a 
              href="https://www.instagram.com/v.rudt/" 
              target="_blank" 
              rel="noreferrer"
              className="w-full sm:w-auto px-8 py-4 bg-orange-500 hover:bg-orange-400 text-zinc-950 font-bold uppercase tracking-wider rounded-sm transition-all flex items-center justify-center gap-2 group"
            >
              <SafeIcon icon={FiIcons.FiInstagram} className="w-5 h-5 group-hover:scale-110 transition-transform" />
              Auf Instagram folgen
            </a>
            <a 
              href="#contact" 
              onClick={scrollToContact}
              className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-zinc-700 hover:border-orange-500 text-white font-bold uppercase tracking-wider rounded-sm transition-all flex items-center justify-center gap-2"
            >
              Zusammenarbeiten
            </a>
          </motion.div>
        </div>
      </div>

      <motion.div 
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex flex-col items-center gap-2 text-zinc-500"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
      >
        <span className="text-xs uppercase tracking-widest font-bold">Scroll</span>
        <motion.div animate={{ y: [0, 10, 0] }} transition={{ repeat: Infinity, duration: 1.5 }}>
          <SafeIcon icon={FiIcons.FiArrowDown} className="w-5 h-5 text-orange-500" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;